/* Pitstop Pro cart drawer, "Add to your order" strip:
   1. move it out of the scrolling cart body so it is always visible, and
   2. on DESKTOP only, add prev/next arrows to page through the options.

   Why it is moved (1): ps-cart-recs renders .ps-recs inside .ps-drawer__body, which is
   the vertical scroller. Keeping it visible there meant position:sticky, i.e. a
   horizontal scroller inside a sticky element inside a vertical scroller. That works in
   Chromium but is a long-standing flaky combination in iOS Safari, where the sticky
   element gets its own layer and the horizontal gesture is never delivered.

   Why arrows (2): touch users swipe the strip, which works. Desktop users have no
   horizontal wheel axis on a normal mouse and the scrollbar is hidden, so there was no
   way to reach the second and third cards. The arrows are injected always but revealed
   only above 900px by the stylesheet, so resizing works in both directions and the
   mobile layout is untouched.

   The drawer is re-rendered wholesale by the Section Rendering API on every cart
   change, so this re-runs on DOM changes. Idempotent throughout. */
(function () {
  'use strict';
  var timer = null;

  function drawerParts() {
    var drawer = document.querySelector('.ps-drawer');
    if (!drawer) return null;
    return {
      panel: drawer.querySelector('.ps-drawer__panel'),
      body: drawer.querySelector('.ps-drawer__body'),
      foot: drawer.querySelector('.ps-drawer__foot')
    };
  }

  function dock(p) {
    var inBody = p.body && p.body.querySelector('.ps-recs');
    if (!inBody) return;
    var stale = p.panel.querySelector(':scope > .ps-recs');
    if (stale && stale !== inBody) stale.remove();
    inBody.classList.add('ps-recs--docked');
    if (p.foot) p.panel.insertBefore(inBody, p.foot);
    else p.panel.appendChild(inBody);
  }

  function step(list) {
    var card = list.querySelector('.ps-rec');
    if (!card) return list.clientWidth;
    var gap = parseFloat(getComputedStyle(list).columnGap) || 0;
    return Math.round(card.getBoundingClientRect().width + gap);
  }

  function sync(list, prev, next) {
    var max = list.scrollWidth - list.clientWidth;
    prev.disabled = list.scrollLeft <= 1;
    next.disabled = list.scrollLeft >= max - 1;
  }

  function arrows(recs) {
    var list = recs.querySelector('.ps-recs__list');
    if (!list || recs.querySelector('.ps-recs__arrow')) return;

    function make(dir, glyph, label) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'ps-recs__arrow ps-recs__arrow--' + dir;
      b.setAttribute('aria-label', label);
      b.textContent = glyph;
      return b;
    }
    var prev = make('prev', '‹', 'Previous suggestion');
    var next = make('next', '›', 'Next suggestion');

    prev.addEventListener('click', function () { list.scrollBy({ left: -step(list), behavior: 'smooth' }); });
    next.addEventListener('click', function () { list.scrollBy({ left: step(list), behavior: 'smooth' }); });
    list.addEventListener('scroll', function () { sync(list, prev, next); }, { passive: true });

    recs.insertBefore(prev, list);
    recs.insertBefore(next, list.nextSibling);
    sync(list, prev, next);
  }

  function run() {
    var p = drawerParts();
    if (!p || !p.panel) return;
    dock(p);
    var recs = p.panel.querySelector('.ps-recs');
    if (recs) arrows(recs);
  }
  function schedule() { clearTimeout(timer); timer = setTimeout(run, 60); }

  function init() {
    run();
    if (window.MutationObserver) {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
